// extracted by mini-css-extract-plugin
export default {"accordionHeader":"DeleteRequest_accordionHeader__DKe30","accordionItem":"DeleteRequest_accordionItem__wE1-7"};